import { fbDB } from "../config/firebase";
import { VOTING_OPEN_TOGGLE } from "./types";

export const votingOpenToggle = (votingType, cCode) => async dispatch => {
  console.log(votingType, cCode);
  fbDB.ref(`/${votingType}/${cCode}/open`).transaction(bool => {
    return !bool;
  });
};
